
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    CleverEventPopup,
  },
})
export default class CleverEventPopup extends Vue {
  private firstName = this.$auth.user().name.split(" ")[0];

  private eventAnnounceStartDate = this.$moment("2023-03-08 00:01");
  private minsEventAnnounceCooldown = 1440; // TODO: del platforms in isShowPopup()
  private cleverEventTime = this.$moment("2023-03-08 23:59"); // always add 1 min here (because of number rounding)
  private minsCountdown = 0; // -10
  private minsActiveAfterBegin = 0; // 10
  private scheduleURL = "";
  private eventURL = "";
  private imageFileName = "Integridade.png";
  private platforms = ['wine', 'wine-eventos', 'wine-eventos-first-sale', 'genialinvestimentos', 'pravaler']

  private femaleUsers: string[] = [
  ]

  // get url location to show info only at dashboard
  private currentLocation = window.location.pathname;

  private eventMinsLeft() {
    const minsLeft = this.$moment().diff(this.cleverEventTime, "minutes");
    return minsLeft;
  }

  private isEventAnnouncement() {
    return (
      this.$moment().diff(this.eventAnnounceStartDate, "minutes") >= 0 &&
      this.eventMinsLeft() < this.minsCountdown
    );
  }

  private isEventCountdown() {
    const minsLeft = this.eventMinsLeft();
    return minsLeft >= this.minsCountdown && minsLeft < 0;
  }

  private isEventActive() {
    const minsLeft = this.eventMinsLeft();
    return minsLeft >= 0 && minsLeft < this.minsActiveAfterBegin;
  }

  private isShowPopup() {
    const eventPopupTime: any = localStorage.getItem("eventPopupTime");
    const isCooldownOver =
      this.$moment().diff(eventPopupTime, "minutes") >=
      this.minsEventAnnounceCooldown;
    /* return (
       (
       this.platforms.includes(this.$auth.user().platform_name) &&
       ['operator'].includes(this.$auth.user().profile) &&
        // Do not show in Lead screens
       this.currentLocation !== "/lead" &&
       !this.currentLocation.includes("/lead/") &&
         (!eventPopupTime || isCooldownOver) &&
         this.isEventAnnouncement()) ||
       this.isEventCountdown() ||
       this.isEventActive()
    ); */

    // International Women's day
    /*return (
      (!eventPopupTime || isCooldownOver) &&
      this.isEventAnnouncement() &&
      this.femaleUsers.includes(this.$auth.user().email)
    );*/

    // company modal values
    return false;
   }

   private getWeek(d){
        const week:any = new Date(d.getFullYear(), 0, 1);
        return Math.ceil(((d - week) / 86400000 + week.getDay() + 1) / 7);
    }

  private async created() {
    const eventPopupTime: any = localStorage.getItem("eventPopupTime");
    const dateLocalStorage:any = new Date(eventPopupTime);
    const dateNow = new Date();

      if (this.$auth.user().profile !== 'operator' && (this.isShowPopup() ||
          (this.getWeek(dateLocalStorage) !== this.getWeek(dateNow)))) {
      localStorage.setItem("eventPopupTime", String(this.$moment()));
      setTimeout(() => {
        this.$bvModal.show("clever-event");
      }, 200);
    }
  }
}
